import { Component, OnInit } from '@angular/core';
import { InteractionService } from '../../services/interaction.service';
import { map } from 'rxjs/operators';

@Component({
     selector: 'app-inactivity-progress-bar',
     templateUrl: './inactivity-progress-bar.component.html',
     styleUrls: [`./inactivity-progress-bar.component.scss`],
})
export class InactivityProgressBarComponent implements OnInit {
     progressPerc = 0;

     constructor(private interactionService: InteractionService) {}

     ngOnInit() {
          this.interactionService?.timeLeft$
               .pipe(
                    map(
                         (value) =>
                              100 -
                              Math.floor(
                                   (value /
                                        this.interactionService
                                             .maxSessionInactivitySecond) *
                                        100
                              )
                    )
               )
               .subscribe((value) => {
                    this.progressPerc = value;
               });
     }
}
